import type { CarrierServiceCode, DeliveryType } from '@purchase-details/types/index.mts';
import type { SummaryStatusCode } from '@/types/index.mjs';

// CONSTANTS

export const ERROR_VALID_ORDER_NUMBER = 'Please enter a valid order number. Note: In-store purchases are not available for order lookup.';
export const ERROR_VALID_ZIP_CODE = 'Please enter a valid ZIP code.';
export const ERROR_LAST_NAME = 'Please enter the last name.';
export const SCS_PHONE_NUMBER = '1-800-426-4840';
export const MASK_PRIVACY_MESSAGE = 'Hidden for privacy';
export const GIFT_MEMBERSHIP_SKU = '6485930017';
export const MEMBERSHIP_SKU = '6485920018';
export const RETURNED_STATUS_CODES: SummaryStatusCode[] = ['0015', '0016', '0017', '0018', '0019'];

// URLS

export const URL_LOGIN_TO_ORDER_LOOKUP = '/login?toUrl=/purchase-history/order-lookup';
export const URL_PURCHASE_HISTORY = '/purchase-history';
export const URL_RETAIL_PURCHASE_HISTORY = '/retail-purchase-history';
export const URL_ACCOUNT = '/account';
export const URL_MEMBER_REWARDS = '/account/member-rewards';
export const URL_MEMBERSHIP = '/membership';
export const URL_MEMBERSHIP_FAQS = '/membership#faq';
export const URL_MEMBERSHIP_BENEFITS = '/membership/benefits';
export const URL_HELP = '/help';
export const URL_DELIVERY_ISSUES = '/help/delivery-issues';
export const URL_RETURN_POLICY = '/help/returns';
export const URL_RETURN_POLICY_EXCEPTIONS = '/help/returns#return-policy-exceptions';
export const URL_CONTACT_US = '/help?article=contact-rei';
export const URL_REI_ACCOUNTS_FAQ = '/help?a=REI-Online-Account-FAQ---id--ckxuORrTR2et6QP5FUOlpg';
export const CANCELED_ORDERS_HELP_URL = '/help?a=Refunds-for-Mailed-in-and-Canceled-Orders---id--C0txBBPqQaaVIWcRQWUTuw';
export const URL_HELP_MY_ORDERS = '/help/categories?hc=myOrders';
export const URL_HELP_CANCEL_OR_MODIFY_ORDER = '/help/categories?hc=cancelOrModifyOrder';
export const URL_HELP_RETURNS_EXCHANGES = '/help/helpCenters?hc=returnsExchanges';
export const URL_HELP_MEMBER_REWARDS = '/help/categories?hc=membershipRewards';
export const URL_HELP_PAYMENT_GIFT_CARDS = '/help/categories?hc=paymentGiftCards';
export const URL_HELP_SHIPPING_INFORMATION = '/help/categories?hc=shippingInformation';
export const URL_HELP_ACCOUNT_LOGIN = '/help/categories?hc=accountLogin';
export const URL_HELP_COUPONS_PROMOTIONS = '/help/categories?hc=couponsPromotions';
export const URL_HELP_SOMETHING_ELSE = '/help/categories?hc=somethingElse';
export const URL_PAYMENT_DETAILS_SECTION = '#payment-details-summary';
export const URL_NO_MEDIA = '/media/00000000-0000-0000-0000-000000000000';
export const URL_COLORADO_FEE_INFO = 'https://tax.colorado.gov/retail-delivery-fee';
export const URL_MINNESOTA_FEE_INFO = 'https://www.revenue.state.mn.us/retail-delivery-fee';
export const REI_LOGO = 'https://satchel.rei.com/media/img/header/rei-co-op-logo-black.svg';
export const URL_REFUND_ESTIMATE_TOOL = '/help/refund-status#/refund-form';
export const URL_REWARDS_EXCEPTIONS = '/help?a=What-items-are-not-eligible-for-Co-op-Member-Rewards---id--t6fN2s_BT_-ftQbOBpoUsg';

// MAPS

export const DELIVERY_TYPES: Record<DeliveryType, string> = {
  EMAIL: 'Email delivery',
  PICKUP: 'Store pickup',
  BOPUS: 'Store pickup',
  RSPU: 'Store pickup',
  VSPU: 'Store pickup',
  DTC: 'Ship to address',
  CANCELED: 'Cancellations',
  BACKORDERED: 'Back ordered',
  RETAIL: 'Purchased in store',
};
export const CARRIER_SERVICE_CODES: Record<CarrierServiceCode, string> = {
  1: 'Standard shipping',
  2: 'Faster shipping',
  3: 'Fastest shipping',
  4: 'Gift card standard shipping',
  5: '',
  6: 'Gift card express shipping',
};
